// Whakawhānaunga session slots: Tuesdays and Thursdays at 7am, 12pm, and
// 7pm Pacific/Auckland time, from viewing-day + 7 days through viewing-day
// + 1 calendar month. Offsets derived via Intl so NZST/NZDT needs no
// hardcoding. Mirrors the gateway's booking-slots.mjs (matou_forms role in
// matou-distributed-servers) — keep the two in sync.

const SLOT_WEEKDAYS = [2, 4]; // Tue, Thu (Date#getUTCDay numbering)
const SLOT_HOURS = [7, 12, 19];
const NZ = 'Pacific/Auckland';

function aucklandToday(now: Date): { y: number; m: number; d: number } {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-CA', {
      timeZone: NZ, year: 'numeric', month: '2-digit', day: '2-digit',
    }).formatToParts(now).map((p) => [p.type, p.value]),
  ) as Record<string, string>;
  return { y: +parts.year, m: +parts.month - 1, d: +parts.day };
}

// Minutes Auckland is ahead of UTC at the given instant (720 NZST, 780 NZDT).
function aucklandOffsetMinutes(date: Date): number {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-CA', {
      timeZone: NZ, hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit',
    }).formatToParts(date).map((p) => [p.type, p.value]),
  ) as Record<string, string>;
  const asUtc = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute);
  return (asUtc - date.getTime()) / 60000;
}

// UTC instant of y-m-d h:00 Auckland wall time. The second pass converges
// when the first guess lands on the other side of a DST transition.
function aucklandWallTimeToUtc(y: number, m: number, d: number, h: number): Date {
  let ts = Date.UTC(y, m, d, h);
  for (let i = 0; i < 2; i++) {
    ts = Date.UTC(y, m, d, h) - aucklandOffsetMinutes(new Date(ts)) * 60000;
  }
  return new Date(ts);
}

function daysToOneMonthOut(now: Date): number {
  const { y, m, d } = aucklandToday(now);
  return Math.round((Date.UTC(y, m + 1, d) - Date.UTC(y, m, d)) / 86400000);
}

export function sessionSlots(now: Date = new Date()): Date[] {
  const { y, m, d } = aucklandToday(now);
  const slots: Date[] = [];
  for (let i = 7; i <= daysToOneMonthOut(now); i++) {
    const day = new Date(Date.UTC(y, m, d + i));
    if (!SLOT_WEEKDAYS.includes(day.getUTCDay())) continue;
    for (const h of SLOT_HOURS) {
      slots.push(aucklandWallTimeToUtc(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate(), h));
    }
  }
  return slots;
}
